import { render, staticRenderFns } from "./blogcomment.vue?vue&type=template&id=cf2d6898&"
import script from "./blogcomment.vue?vue&type=script&lang=js&"
export * from "./blogcomment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports